<template>
  <icomoon :iconSet="iconSet" v-bind="$props" />
</template>

<script>
  import { Icomoon } from "vue-icomoon";
  import iconSet from "./selection.json";

  export default {
    name: "IcoMoon",
    components: { Icomoon },
    setup() {
      return {
        iconSet,
      };
    },
  };
</script>
